import type { TreasuryData } from "./types";

export const TREASURY_EMPTY_RESULT: TreasuryData = {
  assets: [],
  totalUsd: 0n,
};
